import request from "@/utils/request";
import qs from "qs";

export const test = data =>
  request.post("/", qs.stringify(data), {
    headers: { "content-type": "application/x-www-form-urlencoded" }
  });

/**
 * 获取站点信息
 * @param {*} params
 */
export const getStationInfo = params => request.get("/station-info", params);

/**
 * 获取待取件列表
 * @param {*} params
 */
export const getUserExpressList = params =>
  request.get("/pks-secret-phone", { params });

/**
 * 根据包裹Id开箱
 * @param {number} id
 */
export const userPickup = id => request.put(`/openbox/${id}`);
/**
 * 根据uuid获取快递员投递登录二维码地址
 * @param {string} uuid
 */
export const partnerLoginUrl = uuid =>
  request.get(`/partner-login-url/${uuid}`);
/*
 * 根据uuid获取登录状态
 * @param {string} uuid
 */
export const loginStatus = uuid => request.get(`/partner-login-status/${uuid}`);

/*
 * 根据快递员id获取基本信息
 * @params {string} id
 */
export const partnerInfo = id => request.get(`/partner-info/${id}`);
/*
 * 获取快递员充值二维码
 * @params {string} partner 快递员id
 * @params {number} fee 充值金额
 * @params {number} present 赠送金额
 */
export const partnerRechargeConfig = data =>
  request.post("/partner-recharge-config", data);
/*
 * 根据单号查询单号信息
 * @params {string} mailNo 单号
 */
export const mailNoInfo = mailNo => request.get(`/codeInfo/${mailNo}`);
/*
 * 获取快递公司列表
 */
export const getExComList = () => request.get("/excom");
/*
 * 获取可用格子数据
 */
export const availableCabinet = () => request.get("/available-cabinet");
/*
 * 输入电话获取候选电话列表
 * @param {string} chapter 大于4位的电话后几位
 */
export const phoneTips = chapter => request.get(`/phone-tips/${chapter}`);
/*
 * 入站
 * @param {string} code 单号
 * @param {string} phone 电话
 * @param {string} boxSize 格子规格
 * @param {string} name 客户姓名
 * @param {string} excom 公司拼音
 */
export const inbound = data => request.post("/inbound", data);
/*
 * 获取客户超时支付二维码
 * @param {string} id 包裹id
 * @return {string} orderId 单号
 * @return {string} url 微信支付二维码uri
 */
export const overtimeQrcodeUrl = id =>
  request.get(`/overtime-qrcode-url/${id}`);

/**
 * 获取逾期支付状态
 * @param {number} orderId 订单编号
 */
export const getOverTimePayStatus = orderId =>
  request.get(`/overtime-pay-status/${orderId}`);
